// extracted by extract-css-chunks-webpack-plugin
module.exports = {"Button":"lpwgcLYb","disabled":"LXmd7p4o"};